var $04b95a913031932b$exports = {};
$04b95a913031932b$exports = {
    "alert": `Varning`,
    "dismiss": `Avvisa`
};


export {$04b95a913031932b$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
